<template>
  <div>
    <v-notification>
    </v-notification>
    <Modal
        :style="showModalAdd ? 'display: block' : 'display: none'"
        :show="showModalAdd"
        modal-class="withdrawal-funds-modal"
        @close="toggleShowModalAdd"
        :scrollable="true"

    >
      <template #body>
        <div class="modal-content" style="width: 660px">
          <div class="modal-title">{{ getLocalization('Set up maxPrice') }}</div>
          <div class="withdrawal-funds-modal__form">
            <div class="--label">{{ getLocalization('Country') }}</div>
            <div class="mt-1">
              <multiselect
                  v-model="filterCountries"
                  :placeholder="getLocalization('Select country')"
                  label="title"
                  track-by="title"
                  :options='countriesList'
                  :option-height="40"
                  :show-labels="false"
                  :allow-empty="true"
                  :multiple="true"
                  :closeOnSelect="false"
              >
                <template slot="option" slot-scope="props">
                  <img :src="props.option.img_path">
                  <span>{{ props.option.title }}</span>
                </template>
              </multiselect>
            </div>

            <div class="--label">{{ getLocalization('Service') }}</div>
            <div class="mt-1">
              <multiselect
                  v-model="filterServices"
                  :placeholder="getLocalization('Select service')"
                  label="title"
                  track-by="title"
                  :options='servicesList'
                  :option-height="40"
                  :show-labels="false"
                  :allow-empty="true"
                  :multiple="true"
                  :closeOnSelect="false"
              >
                <template slot="option" slot-scope="props">
                  <img :src="props.option.img_path">
                  <span>{{ props.option.title }}</span>
                </template>
              </multiselect>
            </div>

            <div>
              <div class="--label">{{ getLocalization('MaxPrice') }}</div>
              <input
                  type="text"
                  class="input"
                  v-model="newMaxPrice"
                  :placeholder="getLocalization('MaxPrice')"
              />

            </div>


          </div>
          <div class="withdrawal-funds-modal__submit">
            <button
                @click="addItems"
                class="button orange"
            >
              <img src="/img/svg/common/check-circle.svg"/>
              {{ getLocalization('Set up maxPrice') }}
            </button>
          </div>
        </div>
      </template>
    </Modal>
    <div class="activation-history__title set-max-price-title">
      <img src="/img/svg/common/document-check.svg" alt=""/>
      <h1>{{ getLocalization('Set up maxPrice') }}</h1>
    </div>
    <div>
      <div class="circle d-flex">
        <img src="/img/svg/advantages/question.svg" alt="?">
        <p class="ms-2">{{getLocalization('When setting maxPrice manually, all values passed via API will be ignored')}}</p>
      </div>
    </div>
    <div class="--all">
      <div class="activation-history-all">
        <div class="activation-history-all__mobile-content">
          <div
              id="activation-history-all-filter"
              class="activation-history-all__filter show set-max-price-filters"
          >
            <button @click="toggleShowModalAdd" class="button primary orange">{{ getLocalization('Set up maxPrice') }}</button>
            <base-table
                ref="baseTable"
                :columns="this.columns"
                table-class="vgt-table activation-history-all__table new-design-table"
                :render-list-to-show="this.listToShow"
                :wrapperFiltersData="this.wrapperFiltersData"
                :table-title="null"
                :accept-filters-button-label="getLocalization('Apply filters')"
                new-design-class="activation-history-partner__body set-max-price-table"
            >
              <template v-slot:base-table-row="props">
                <td v-if="props.column.field === 'country'" class="d-flex gap-2 align-items-center">
                  <img :src="props.row['country_img_path']" alt="" width="20px" style="border-radius: 5px">
                  {{ getLocalization(props.formattedRow[props.column.field]) }}
                </td>
                <td v-else-if="props.column.field === 'service'" class="d-flex gap-2 align-items-center">
                  <img :src="props.row['service_img_path']" alt="" width="20px">
                  {{ getLocalization(props.formattedRow[props.column.field]) }}
                </td>
                <td v-else-if="props.column.field === 'delete'">
                  <button @click="deletePrice(props.row.id)" class="button primary btn-danger">{{ getLocalization('Delete') }}</button>
                </td>
                <template v-else>
                  <td>{{ props.formattedRow[props.column.field] }}</td>
                </template>
              </template>
            </base-table>
          </div>
        </div>
        <div class="activation-history-all__items">
          <div class="activation-history-all-card" v-for="stat in priceList">
            <div class="--item">
              <div class="--label">{{ getLocalization('Country') }}</div>
              <div class="--value">{{ stat['country'] }}</div>
            </div>
            <div class="--item">
              <div class="--label">{{ getLocalization('Service') }}</div>
              <div class="--value">{{ stat['service'] }}</div>
            </div>
            <div class="--divider"></div>
            <div class="--item">
              <div class="--label">maxPrice</div>
              <div class="--value">{{ stat['max_price'] }} ₽</div>
            </div>
            <div class="--item">
              <button class="button primary btn-danger" @click="deletePrice(stat.id)">{{ getLocalization('Delete') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import WrapperFiltersComponent from "../../../components/table/wrapperFilters.vue";
import BaseSendRequestMixin from "../../../components/mixins/BaseSendRequestMixin.vue";
import BaseMessagingMixin from "../../../components/mixins/BaseMessagingMixin.vue";
import BaseTable from "../../../components/table/baseTable.vue";
import BarChart from "../../../components/LineChart/barChart.vue";
import GraphDynamic from "../../../components/mixins/GraphDynamicMixin";
import Modal from "../../../components/table/modalNew.vue";

export default {
  name: "phoneHistory",
  mixins: [
    BaseSendRequestMixin,
    BaseMessagingMixin,
    GraphDynamic
  ],
  components: {
    Modal,
    BarChart,
    BaseTable,
    Multiselect,
    WrapperFiltersComponent
  },
  props: [
    'providers',
  ],
  data: function () {
    return {
      wrapperFiltersData: {
        title: this.getLocalization('Activations history'),
        filtersUrl: '/cabinet/client/setmaxprice/getList',
        showResetFilterButton: true,
        startWithRequest: true,
        showCollapseFilter: true,
        newDesign: true,
        items: {
          countries: {
            enable: true,
            multiple: true,
            getDataLink: '/countries/getList',
            placeholder: this.getLocalization('Country'),
            viewLabel: 'title',
            className: '--6-12',
            needLocalization: true
          },
          services: {
            enable: true,
            multiple: true,
            getDataLink: '/services/getList',
            placeholder: this.getLocalization('Service'),
            viewLabel: 'title',
            className: '--6-12',
          }
        }
      },
      perPage: 50,
      columns: [
        {
          label: this.getLocalization('Country'),
          field: 'country',
          sortable: false,
          width: '30%'
        },
        {
          label: this.getLocalization('Service'),
          sortable: false,
          field: 'service',
          width: '30%'
        },
        {
          label: 'maxPrice',
          field: 'max_price',
          type: 'number',
          sortable: true,
          width: '20%'
        },
        {
          label: this.getLocalization('Delete'),
          field: 'delete',
          width: '20%',
          sortable: false,
        }
      ],
      loaded: false,
      priceList: [],
      showModalAdd: false,
      filterCountries: [],
      countriesList: [],
      servicesList: [],
      filterServices: [],
      newMaxPrice: null
    }
  },
  async mounted() {
    this.countriesList = await this.sendRequest('/countries/getList');
    this.servicesList = await this.sendRequest('/services/getList');
  },
  methods: {
    listToShow(list) {
      let data = [];
      for (let elem of list) {
        data.push({
          id: elem['id'],
          service: elem['service_variation']['service']['title'],
          service_img_path: elem['service_variation']['service']['img_path'],
          country: this.getLocalization(elem['service_variation']['country']['title']),
          country_img_path: elem['service_variation']['country']['img_path'],
          max_price: Number(elem['max_price']).toFixed(2),
        });
      }
      this.priceList = data;
      return data;
    },
    async deletePrice(id) {
      await this.doWithStopRequest(async () => {
        let response = await this.sendRequest(
            '/cabinet/client/setmaxprice/delete',
            'post',
            {
              id: id
            }
        );
        if (response.status === 'ok') {
          let index = this.getIndexByProp(this.priceList, 'id', id);
          this.filteredList.splice(index, 1);
          this.$root.$emit('update-list');
          await this.alertMessage(
              'Item has been deleted',
              'info'
          );
        } else {
          await this.alertMessage(
              'Item has not been deleted',
              'error'
          );
        }
      })
    },
    getIndexByProp(list, propKey, propValue) {
      for (let key in list) {
        if (list[key][propKey] == propValue) {
          return key;
        }
      }

      return null;
    },
    toggleShowModalAdd() {
      this.showModalAdd = !this.showModalAdd;
    },
    clearModalData() {
      this.filterCountries = [];
      this.filterServices = [];
      this.newMaxPrice = null;
    },
    async addItems()
    {
      let data = {
        countriesIds: this.filterCountries.map(item => item.id),
        servicesIds: this.filterServices.map(item => item.id),
        max_price: this.newMaxPrice,
      };
      let response = await this.sendRequest(
          '/cabinet/client/setmaxprice/addMany',
          'post',
          data,
      );

      if (response) {
        this.priceList.unshift(...response['data']);
        this.$root.$emit('update-list', data);
        await this.alertMessage('Items successfully added');
        this.clearModalData();
        this.toggleShowModalAdd();
      }
    },
  },

}
</script>
